/** @format */

import React from "react";
import { ReactComponent as Up } from "bootstrap-icons/icons/arrow-up.svg";
import { ReactComponent as Down } from "bootstrap-icons/icons/arrow-down.svg";
import { getCurrentParams, updateQueryStorage } from "../resourceIndexUI/utils";
import { useTranslation } from "react-i18next";
import { ResourceReference, UserResourceReference } from "../../../types";
import { QueryProps } from "../resourceIndexUI/ResourcesIndexUI";
type Props = {
  query: QueryProps;
  pageKey: string;
  updateSearchParams: (value: { [key: string]: string }) => void;
  filteredResources?: ResourceReference[] | UserResourceReference[];
};

const ResourceSort: React.FC<Props> = ({
  query,
  pageKey,
  updateSearchParams,
  filteredResources,
}) => {
  const { t: _ } = useTranslation();
  const { sort, level } = query;

  const handleSortNameClick = () => {
    const params = getCurrentParams(query);
    switch (sort) {
      case "name":
      case "enw":
      case "name<":
      case "enw<":
        params.sort = "name>";
        break;
      default:
        params.sort = "name<";
    }
    updateQueryStorage(params, pageKey);
    updateSearchParams(params);
  };

  const handleSortDateClick = () => {
    const params = getCurrentParams(query);
    switch (sort) {
      case "date":
      case "date>":
        params.sort = "date<";
        break;
      default:
        params.sort = "date>";
    }
    updateQueryStorage(params, pageKey);
    updateSearchParams(params);
  };

  const handleSortLevelClick = () => {
    const params = getCurrentParams(query);
    switch (sort) {
      case "level":
      case "level<":
        params.sort = "level>";
        break;
      default:
        params.sort = "level<";
    }
    updateQueryStorage(params, pageKey);
    updateSearchParams(params);
  };

  return (
    <div className="sort d-flex flex-column flex-md-row gap-0 gap-md-3 mb-3">
      <div className="col mb-2">
        <button
          aria-label={_("Sort by Name")}
          disabled={!filteredResources?.length}
          className="btn btn-lg btn-dark w-100 h-100 lh-sm"
          onClick={() => handleSortNameClick()}
        >
          <span>{_("Sort by Name")}</span>{" "}
          <em className="text-nowrap">({_("A-Z")})</em>
          &thinsp;
          {["name", "enw", "name<", "enw<"].includes(sort || "") && <Down />}
          {["name>", "enw>"].includes(sort || "") && <Up />}
        </button>
      </div>
      <div className="col mb-2">
        <button
          aria-label={_("Sort by Date")}
          disabled={!filteredResources?.length}
          className="btn btn-lg btn-dark w-100 h-100 lh-sm"
          onClick={() => handleSortDateClick()}
        >
          <span>{_("Sort by Date")}</span>{" "}
          <em className="text-nowrap">({_("New-Old")})</em>
          &thinsp;
          {["date", "date>"].includes(sort || "") && <Down />}
          {["date<"].includes(sort || "") && <Up />}
        </button>
      </div>
      <div className="col mb-2">
        <button
          aria-label={_("Sort by Level")}
          disabled={!filteredResources?.length || !!level}
          className="btn btn-lg btn-dark w-100 h-100 lh-sm"
          onClick={() => handleSortLevelClick()}
        >
          <span>{_("Sort by Level")}</span>{" "}
          <em className="text-nowrap">
            ({_("KS", { keystage: "3" })}-{_("KS", { keystage: "5" })})
          </em>
          &thinsp;
          {["level", "level<"].includes(sort || "") && <Down />}
          {["level>"].includes(sort || "") && <Up />}
        </button>
      </div>
    </div>
  );
};

export default ResourceSort;
